// @flow

import * as React from 'react';
import classNames from '../../utils/classNames';

import styles from './SearchWrapper.module.css';

type Props = {
  children: React.Node,
  wrapperRef: Function,
  active: boolean,
  width: string,
  widthActive: string,
};

const SearchWrapper = ({
  children,
  wrapperRef,
  active,
  width,
  widthActive,
}: Props) => {
  const searchWrapperRef = React.createRef();

  wrapperRef(searchWrapperRef);

  return (
    <div
      className={styles.root}
      style={{ width: active ? widthActive : width }}
    >
      <div
        ref={searchWrapperRef}
        className={classNames(
          styles.wrapper,
          active ? styles.wrapperOpen : null
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default SearchWrapper;
